import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/kellymears/code/projects/cli/bud/bud-sandbox/web/app/themes/wp-react-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "usefontsizes"
    }}>{`useFontSizes`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`useFontSizes`}</inlineCode>{` hook provides an interface for consuming and modifying the block editor preset font sizes.`}</p>
    <h2 {...{
      "id": "basics"
    }}>{`Basics`}</h2>
    <p><strong parentName="p">{` Import `}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useFontSizes} from '@tinypixelco/wp-react-hooks'
`}</code></pre>
    <p><strong parentName="p">{` Use `}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const {fontSizes, setFontSizes, addColor} = useFontSizes()
`}</code></pre>
    <p><strong parentName="p">{` The `}<inlineCode parentName="strong">{`fontSizes`}</inlineCode>{` array is made up of objects that are shaped like this `}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`{
  name: 'Small',
  shortName: 's',
  size: 8,
  slug: 'small',
}
`}</code></pre>
    <h2 {...{
      "id": "list-font-sizes"
    }}>{`List font sizes`}</h2>
    <p>{`List all the font sizes registered with WordPress.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useFontSizes} from '@tinypixelco/wp-react-hooks'

const component = () => {
  const [fontSizes] = useFontSizes()

  return (
    <div>
      {fontSizes && JSON.stringify(fontSizes)}
    </div>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "addfontsize"
    }}>{`addFontSize`}</h2>
    <p>{`Add a font size to the existing presets.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`{addFontSize} = useFontSizes()

addFontSize({
  name: 'Dynamic',
  shortName: 'd',
  size: 69,
  slug: 'dynamic',
})
`}</code></pre>
    <h2 {...{
      "id": "setfontsizes"
    }}>{`setFontSizes`}</h2>
    <p>{`Replace the preset sizes with a new set.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`{setFontSizes} = useFontSizes()

setFontSizes([
  {
    name: 'Dynamic',
    shortName: 'd',
    size: 69,
    slug: 'dynamic',
  },
])

### addFontSize

\`\`\`jsx
{fontSizes, setFontSizes} = useFontSizes()

const newFontSize = {
  name: 'Dynamic',
  shortName: 'd',
  size: 69,
  slug: 'dynamic',
}

useEffect(() => {
  setSettings({
    fontSizes: [
      ...fontSizes,
      newFontSize,
    ],
  })
}, [])
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`
export const _frontmatter = {}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      